import store from '@/store';
import MasterServices from "@/apiServices/masterServices";
import homeServices from '@/apiServices/homeServices';
import StrapiServices from '@/apiServices/StrapiServices';

function initialState() {
  return {
    Countries: [],
    allCountryAndCitites: [],
    allDegreesAndSubDegrees: [],
    allDisciplinesAndSubDisciplines: [],
    CourseLevels: [],
    CourseCategories: [],
    TuitionFeesFilterValues: [],
    TuitionUSDFeesFilterValues: [],
    Blogs: []
  }
}

const state = initialState();

const mutations = {
  ON_SET_COUNTRIES: (state, payload) => {
    state.Countries = payload
  },
  ON_SET_COUNTRY_AND_CITIES: (state, payload) => {
    state.allCountryAndCitites = payload
  },
  ON_SET_COURSE_LEVELS: (state, payload) => {
    state.CourseLevels = payload
  },
  ON_SET_COURSE_CATEGORIES: (state, payload) => {
    state.CourseCategories = payload
  },
  ON_SET_TUITION_FEES_FILTER_VALUES: (state, payload) => {
    state.TuitionFeesFilterValues = payload
  },
  ON_SET_TUITION_USD_FEES_FILTER_VALUES: (state, payload) => {
    state.TuitionUSDFeesFilterValues = payload
  },
  ON_SET_BLOGS: (state, payload) => {
    state.Blogs = payload
  },

}

const actions = {

  onGetCountriesAndCities: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COUNTRY_AND_CITIES', [])
    MasterServices.getCountriesAndCities(payload)
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COUNTRY_AND_CITIES', data)
        } else {
          console.log('Error onGetCountriesAndCities ', response);
        }
      }).catch((error) => {
        console.log('Catch Error on onGetCountriesAndCities', error);
      }).finally(async () => {
      });
  },

  onGetCountries: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COUNTRIES', [])
    homeServices.getCountries(payload)
      .then(async (response) => {
        const { data } = response.data
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COUNTRIES', data)
        } else {
          console.log('Error onGetCountriesAndCities ', response);
        }
      }).catch((error) => {
        console.log('Catch Error on onGetCountriesAndCities', error);
      }).finally(async () => {
      });
  },

  onGetTuitionFeesFilterValues: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_TUITION_FEES_FILTER_VALUES', [])
    MasterServices.getTuitionFeesFilterValues(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_TUITION_FEES_FILTER_VALUES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.log('Catch Error on onGetTutionFeesFilterValues', error);
      }).finally(async () => {
      });
  },

  onGetTuitionUSDFeesFilterValues: async ({ dispatch, commit, state }, payload) => {
    await commit('ON_SET_TUITION_USD_FEES_FILTER_VALUES', [])
    MasterServices.getTuitionUSDFeesFilterValues(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_TUITION_USD_FEES_FILTER_VALUES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.log('Catch Error on onGetTutionFeesFilterValues', error);
      }).finally(async () => {
      });
  },

  onGetCourseLevels: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COURSE_LEVELS', [])
    MasterServices.getCourseLevels(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COURSE_LEVELS', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.log('Catch Error on onGetCourseLevels', error);
      }).finally(async () => {
      });
  },

  onGetCourseCategories: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_COURSE_CATEGORIES', [])
    MasterServices.getCourseCategories(payload)
      .then(async (response) => {
        const { data: { data } } = response;
        if (response['data'] && response.data.status) {
          await commit('ON_SET_COURSE_CATEGORIES', data)
        } else {
          store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
        }
      }).catch((error) => {
        console.log('Catch Error on onGetCourseCategories', error);
      }).finally(async () => {
      });
  },

  onGetBlogs: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_SET_BLOGS', [])
    StrapiServices.getBlogs()
      .then(async (response) => {
        await commit('ON_SET_BLOGS', response.data.data);
      })
      .catch((error) => {
        console.log('Catch Error on onGetBlogs', error);
      });
  },
}


const getters = {
  getCountries: state => state.Countries,
  getCountriesAndCities: state => state.allCountryAndCitites,
  getCourseLevels: state => state.CourseLevels,
  getCourseCategories: state => state.CourseCategories,
  getTuitionFeesFilterValues: state => state.TuitionFeesFilterValues,
  getTuitionUSDFeesFilterValues: state => state.TuitionUSDFeesFilterValues,
  getBlogs: state => state.Blogs
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js